import { Checkbox, FormControlLabel } from '@material-ui/core';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import * as React from 'react';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
  },
  checkboxContainer: {
    marginTop: 10,
  },
});

export interface IAgreement {
  id: string | number;
  link?: string;
  [key: string]: any;
}

export interface IAgreementsFormProps extends WithStyles<typeof styles> {
  agreements: IAgreement[];
  onSubmit: (values: { [key: string]: boolean }) => void;
  onFormReady?: (form: AgreementsFormComponent) => void;
  onValidityChange?: (isValid: boolean) => void;
}

export interface IAgreementsFormState {
  values: { [key: string]: boolean };
}

class AgreementsFormComponent extends React.Component<IAgreementsFormProps, IAgreementsFormState> {
  constructor(props: IAgreementsFormProps) {
    super(props);
    const initialValues: { [key: string]: boolean } = {};
    _.each(props.agreements, (agreement) => {
      initialValues[String(agreement.id)] = false;
    });
    this.state = {
      values: initialValues,
    };
  }

  componentDidMount() {
    if (this.props.onFormReady) {
      this.props.onFormReady(this);
    }
    if (this.props.onValidityChange) {
      const isValid = _.some(this.state.values, (value) => value === true);
      this.props.onValidityChange(isValid);
    }
  }

  componentDidUpdate(prevProps: IAgreementsFormProps) {
    if (prevProps.agreements.length !== this.props.agreements.length) {
      const initialValues: { [key: string]: boolean } = {};
      _.each(this.props.agreements, (agreement) => {
        initialValues[String(agreement.id)] = false;
      });
      this.setState({ values: initialValues });
    }
  }

  handleCheckboxChange = (agreementId: string | number) => (event: React.ChangeEvent<HTMLInputElement>) => {
    const { values } = this.state;
    const newValues = {
      ...values,
      [String(agreementId)]: event.target.checked,
    };
    this.setState({ values: newValues });
    if (this.props.onValidityChange) {
      const isValid = _.some(newValues, (value) => value === true);
      this.props.onValidityChange(isValid);
    }
  }

  handleSubmit = (event?: React.FormEvent) => {
    if (event) {
      event.preventDefault();
    }
    this.props.onSubmit(this.state.values);
  }

  getValues = (): { [key: string]: boolean } => {
    return this.state.values;
  }

  isFormValid = (): boolean => {
    return _.some(this.state.values, (value) => value === true);
  }

  render() {
    const { agreements, classes } = this.props;
    const { values } = this.state;
    return (
      <form onSubmit={this.handleSubmit} className={classes.container}>
        {_.map(agreements, (agreement) => (
          <div key={agreement.id} className={classes.checkboxContainer}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={values[String(agreement.id)] || false}
                  onChange={this.handleCheckboxChange(agreement.id)}
                />
              }
              label={`Accept agreement`}
            />
          </div>
        ))}
      </form>
    );
  }
}

const AgreementsForm = withStyles(styles)(AgreementsFormComponent);

export default AgreementsForm;
